import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import { Dialog } from '@headlessui/react';
import { theme } from '@xbto/design-system';
import { useBreakpoints } from '../../hooks';
import { Backdrop } from '../../atoms';
export default function ComponentWeb({ visible, onClose, Header, Body, Footer, options, }) {
    /**
     * Vars
     */
    const { breakpoints } = useBreakpoints();
    const dismissOnBackdrop = (options === null || options === void 0 ? void 0 : options.dismissOnBackdrop) === undefined || (options === null || options === void 0 ? void 0 : options.dismissOnBackdrop);
    /**
     * Handlers
     */
    const handleBackdropClick = useCallback(() => {
        if (dismissOnBackdrop) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [onClose, dismissOnBackdrop]);
    /**
     * DOM
     */
    if (!visible)
        return null;
    // Necessary to prevent style [] assignment to blow with
    // Failed to set an indexed property [0] on 'CSSStyleDeclaration':
    // Indexed property setter is not supported.
    const dialogStyle = breakpoints.MORE_THAN_S
        ? Object.assign(Object.assign({}, $.dialog), $.dialogMd) : $.dialog;
    return (
    // keep zIndex to keep the backdrop from being overriden by the reset class
    _jsxs(View, { style: [$.container, { zIndex: 50 }], children: [_jsx(Backdrop, { onPress: handleBackdropClick }), _jsx(Dialog, { open: visible, onClose: () => { }, style: StyleSheet.flatten([
                    dialogStyle,
                    // keep zIndex to keep the dialog zindex from being overriden by the reset class
                    { zIndex: 51 },
                ]), children: _jsxs(View, { style: $.content, children: [_jsxs(View, { style: [$.scrollArea, breakpoints.LESS_THAN_S && $.scrollAreaSmall], children: [Header && _jsx(View, { style: $.header, children: Header }), _jsx(View, { style: $.body, children: Body })] }), Footer && (_jsx(View, { style: [$.footer, breakpoints.LESS_THAN_S && $.footerSmall], children: Footer }))] }) })] }));
}
const $ = StyleSheet.create({
    container: Object.assign(Object.assign({}, StyleSheet.absoluteFillObject), { 
        // @ts-expect-error This is web only
        position: 'fixed', justifyContent: 'center', alignItems: 'center' }),
    dialog: {
        // @ts-expect-error This is web only
        display: 'grid',
        gridTemplateRows: '1fr auto',
        // @ts-expect-error This is web only
        position: 'fixed',
        width: '100%',
        left: '50%',
        top: 'auto',
        bottom: 0,
        maxHeight: '90vh',
        // @ts-expect-error This is web only
        transform: 'translateX(-50%)',
        boxSizing: 'border-box',
        backgroundColor: theme.color.background.white,
        borderRadius: theme.radius.md,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    dialogMd: {
        maxWidth: theme.modal,
        top: '50%',
        bottom: 'auto',
        // @ts-expect-error This is web only
        transform: 'translate(-50%, -50%)',
        borderBottomLeftRadius: theme.radius.md,
        borderBottomRightRadius: theme.radius.md,
        maxHeight: '80vh',
    },
    content: {
        flex: 1,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    },
    scrollArea: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        // @ts-expect-error web specific
        overflow: 'auto',
        padding: theme.spacing['6'],
    },
    scrollAreaSmall: {
        padding: theme.spacing['4'],
    },
    header: {},
    body: {},
    footer: {
        backgroundColor: theme.color.background.white,
        padding: theme.spacing['6'],
        paddingTop: theme.spacing['2'],
    },
    footerSmall: {
        padding: theme.spacing['4'],
    },
});
